import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import {
  GET_PROJECT_APPLICATION,
  CANCEL_PROJECT_APPLICATION,
} from 'gql/projectApplications';
import { useLoading } from 'hooks';

const { confirm } = Modal;

const showConfirm = ({ onOk }) => {
  confirm({
    title: 'Confirm to Cancel / Revise?',
    icon: <ExclamationCircleOutlined />,
    content: 'Status of this application will be changed to DRAFT',
    onOk,
    maskClosable: true,
  });
};

const CancelProjectApplication = () => {
  const { id } = useParams();
  const [cancel, { loading }] = useMutation(CANCEL_PROJECT_APPLICATION, {
    refetchQueries: [
      {
        query: GET_PROJECT_APPLICATION,
        variables: {
          id: id,
        },
      },
    ],
  });
  const onOk = () => {
    cancel({
      variables: { id },
    });
  };
  useLoading(loading);

  return (
    <Button
      type="primary"
      style={{ marginTop: '16px', marginBottom: '16px' }}
      onClick={() => {
        showConfirm({ onOk });
      }}
    >
      Cancel / Revise Application
    </Button>
  );
};

export default CancelProjectApplication;
